<template>
  <div class="table-action-wrapper update-shipped-order-label" ref="container">
    <div class="position-relative d-flex flex-wrap w-100">
      <label for="uploadFile" class="btn btn-outline-success d-flex align-items-center mb-0 mr-2">
        <input id="uploadFile" type="file" @change="changeFile" style="display: none" />
        <span>Choose File</span>
      </label>
      <a @click.prevent="submit" href="#" class="btn btn-outline-success d-flex align-items-center mb-0 mr-2">
        <span>Submit</span>
      </a>
      <div class="w-100 mt-1">
        <span>Selected: {{ Object.keys(orders).length }} items</span>
      </div>
    </div>
  </div>
</template>
<script>
import { read, utils } from 'xlsx'
export default {
  data() {
    return {
      orders: []
    }
  },
  computed: {
    store() {
      return this.config?.store
    }
  },
  methods: {
    async changeFile(e) {
      const file = e.target.files[0]
      if (!/\.(xlsx|xls|csv)$/i.test(file.name)) {
        alert('Only xlsx/xls/csv format is supported')
        return
      }
      let wb = read(await file.arrayBuffer())
      let data = utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
      this.orders = []
      for (let i = 0; i <= data.length; i++) {
        if (!data[i]?.['Customer Order']) continue
        this.orders.push({
          id: String(data[i]['Customer Order']).replace('#', '')
        })
      }
      e.target.value = ''
    },
    submit() {
      this.$util.post(
        '/order/more/update-shipped-order-label',
        {
          orders: this.orders
        },
        this.$refs.container
      )
    }
  },
  props: {
    config: Object
  }
}
</script>
